export const TextParagraph = ({
  className
}: {
  className?: string;
}) => <svg aria-hidden="true" className={className} fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="TextParagraph" data-sentry-source-file="Text.tsx">
    <path d="M10 12H2M11.3333 4H2M14 8H2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33" data-sentry-element="path" data-sentry-source-file="Text.tsx" />
  </svg>;